<template>
  <div class="phone-validate">
    <div>
      <step-header :step="step"></step-header>
    </div>
    <div class="form-container">
      <div class="title-validate">输入邮箱</div>
      <div class="mail-form">
        <el-form :model="validateFormMail" :rules="mailRules" ref="validateFormMail">
          <el-form-item prop="email">
            <el-input v-model="validateFormMail.email" placeholder="输入联系邮箱，需要验证"></el-input>
          </el-form-item>
          <el-form-item prop="agree" class="tool-agreement">
            <el-checkbox v-model="validateFormMail.agree">
              <span>我同意接受</span>
              <a href="/#/open/developer/agreement" class="link-to-agreement">《腾讯优图AI开放平台开发者协议》</a>
            </el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <div class="next-to-active">
        <button class="c-btn-add" @click="handleSubmitForm" >
          <span class="text">下一步</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/common/api';
import MessageType from '@/components/common/message-box/MessageType';
import RouteKey from '@/common/RouteKey';
import StepHeader from '../common/StepHeader';
export default {
  name: 'mail',
  components: {
    StepHeader
  },
  data() {
    return {
      validateFormMail: {
        email: '',
        check: false
      },
      step: 2,
      mailRules: {
        email: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change']
        }],
        agree: [{
          validator: this.validateAgreement,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    validateAgreement(rule, value, callback) {
      if (value == null || !value) {
        callback(new Error('请阅读腾讯优图AI开放平台开发者协议'));
      }
      callback();
    },
    handleSubmitForm() {
      this.$refs.validateFormMail.validate((valid) => {
        if (!valid) {
          return;
        }
        const loading = this.loading();
        let data = {
          email: this.validateFormMail.email,
          agree: 'on'
        };
        this.$loader.post(api.user.YTMAIL, data).then((res) => {
          this.$alert('邮件发送成功', null, MessageType.SUCCESS);
          this.$router.transfer(RouteKey.OPEN_ACTIVE_MAIL, {email: data.email});
        }).finally(() => {
          loading.close();
        });
      });
    }
  }
};
</script>

<style lang="less">
.phone-validate{
  .title-validate{
    height: 118px;
    line-height: 118px;
    width: 250px;
    margin: 0 auto;
    color: #666666;
    font-size: 24px;
    text-align: center;
    background-image: url(./img/title_element_left.png),  url(./img/title_element_right.png);
    background-repeat: no-repeat;
    background-position: 0px center, right center;
  }
  .form-container{
    background: #ffffff;
    box-shadow: 0px 1px 25px 0px rgba(0, 0, 0, 0.13);
    .mail-form{
      font-size: 0;
      text-align: center;
      .el-form-item{
        margin-bottom: 30px;
      }
      .el-form-item__label{
        color: #666666;
        font-size: 18px;
        margin-right: 18px;
      }
      .el-form-item__content{
        width: 460px;
        height: 40px;
        .el-input__inner{
          height: 40px;
          line-height: 40px;
          border: 1px solid #A2C4F8;
          border-radius: 5px;
        }
      }
      .is-validating .el-form-item__label{
        color:#e94e56;
      }
      .tool-agreement{
        height: 30px;
        .el-checkbox__label{
          line-height: 30px;
          font-size: 16px;
        }
        .el-form-item__content{
          height: 30px;
        }
        .link-to-agreement{
          color: #3385ff;
        }
      }
    }
    .next-to-active{
      text-align: center;
      margin-top: 70px;
      padding-bottom: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/validate/panels/MailValidate.vue